import TransitionExpand from '@/components/TransitionExpand.vue'
import { IAppApplication } from '@/app/application'
import { installI18nPlugin } from '@/i18n/bootstrap'
import type { AppStore } from '@/store/types'

export function registerGlobalComponents(app: IAppApplication): void {
  app.component('TransitionExpand', TransitionExpand)
}

export function installVuePlugins(app: IAppApplication, store: AppStore): void {
  installI18nPlugin(app, store)
}
